import { Box, BoxProps } from '@chakra-ui/react';

const CHECKER_SIZE = 16;
const CHECKER_COLOR = '#E9E9E9';
const CHECKER_BG = '#FAFAFA';

const checkerStyle: React.CSSProperties = {
  backgroundColor: CHECKER_BG,
  backgroundImage: `linear-gradient(45deg, ${CHECKER_COLOR} 25%, transparent 25%), linear-gradient(-45deg, ${CHECKER_COLOR} 25%, transparent 25%), linear-gradient(45deg, transparent 75%, ${CHECKER_COLOR} 75%), linear-gradient(-45deg, transparent 75%, ${CHECKER_COLOR} 75%)`,
  backgroundSize: `${CHECKER_SIZE}px ${CHECKER_SIZE}px`,
  backgroundPosition: `0 0, 0 ${CHECKER_SIZE / 2}px, ${CHECKER_SIZE / 2}px -${CHECKER_SIZE / 2}px, -${CHECKER_SIZE / 2}px 0`,
};

export const ImagePlaceholder: React.FC<BoxProps> = ({ style, ...props }) => (
  <Box
    data-testid="image-placeholder"
    style={{ ...checkerStyle, ...style }}
    {...props}
  />
);
